import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1e1f2ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-epic-common-aes-frame hd-epic-frame-content" }
const _hoisted_2 = { class: "hd-epic__header" }
const _hoisted_3 = { class: "hd-epic__content-flex-inline" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_5 = { class: "hd-epic__content-top" }
const _hoisted_6 = { class: "hd-epic__header" }
const _hoisted_7 = { class: "hd-epic__content-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_overlay_module = _resolveComponent("overlay-module")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__header-section",
        "asset-key": `epic-header-section-${_ctx.section}`
      }, null, 8, ["asset-key"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_lyra_asset, {
          class: "hd-epic__header-title",
          "asset-key": "epic-header-common-aes-title"
        }),
        _createVNode(_component_base_button, {
          callback: _ctx.processOverlay,
          callbackString: "common-aes",
          modifier: "tertiary",
          shape: "circular",
          class: "hd-epic-common-aes-frame__info-chart"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["callback"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_lyra_asset, {
        class: "hd-epic__content-text",
        "asset-key": "epic-common-aes-content-top"
      })
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.overlay === 'common-aes')
          ? (_openBlock(), _createBlock(_component_overlay_module, {
              key: 0,
              class: "hd-epic__overlay"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_lyra_asset, {
                    class: "hd-epic__header-section",
                    "asset-key": `epic-header-section-${_ctx.section}-${_ctx.overlay}`
                  }, null, 8, ["asset-key"]),
                  _createVNode(_component_lyra_asset, {
                    class: "hd-epic__header-title",
                    "asset-key": `epic-header-common-aes-title-${_ctx.overlay}`
                  }, null, 8, ["asset-key"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_lyra_asset, {
                    class: "hd-epic__content-text",
                    "asset-key": `epic-common-aes-content-${_ctx.overlay}`
                  }, null, 8, ["asset-key"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}